/**
 * ResultField - 算出結果表示フィールド (読み取り専用)
 *
 * サイズ・フォント系は上位コンポーネントから props で受け取る。
 * デフォルト値は通常の使用に合わせた値を設定してある。
 *
 * @param {number} value          - 表示する数値
 * @param {string} widthClass     - 幅クラス (例: 'w-52')
 * @param {string} sizeClass      - padding / font-size クラス (例: 'px-2 py-1 text-sm')
 * @param {string} textAlignClass - テキスト揃えクラス (例: 'text-right')
 * @param {string} unit           - 単位ラベル (例: '円')。空文字の場合は非表示
 * @param {string} unitClass      - 単位ラベルのスタイルクラス
 * @param {boolean} signed          - true のとき正の値に "+" を付与する（差額表示用）
 * @param {string} valueColorClass  - 値のテキストカラークラス (例: 'text-red-600')
 */
function ResultField({
  value,
  widthClass = "",
  sizeClass = "px-2 py-1 text-sm",
  textAlignClass = "text-right",
  unit = "円",
  unitClass = "text-sm",
  signed = false,
  valueColorClass = "",
}) {
  const display = (signed && value > 0 ? "+" : "") + value.toLocaleString();

  return (
    <div className="flex items-center m-0 p-0">
      <div
        className={`border border-gray-400 bg-gray-50 ${widthClass} ${sizeClass} ${textAlignClass} ${valueColorClass}`}
      >
        {display}
      </div>
      {unit && <span className={`ml-1 p-1 ${unitClass}`}>{unit}</span>}
    </div>
  );
}

export default ResultField;
